import { render } from "./MyInscriptions.vue?vue&type=template&id=4444c8b6"
import script from "./MyInscriptions.vue?vue&type=script&lang=js"
export * from "./MyInscriptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__